import { combineReducers } from 'redux';

import authorReducer, { AuthorState } from './author/author.reducer';
import serieReducer, { SerieState } from './serie/serie.reducer';
import bookReducer, { BookState } from './book/book.reducer';

export default combineReducers({
  authors: authorReducer,
  series: serieReducer,
  books: bookReducer,
});

export type EntitiesState = {
  readonly authors: AuthorState;
  readonly series: SerieState;
  readonly books: BookState;
};
